import React from 'react'
import { Controller, FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { clsx } from 'clsx'

import * as fieldStyles from '../../_internal/Field/Field.css'
import { FieldOutline } from '../../_internal/Field/FieldOutline/FieldOutline'
import { Stack } from '../../Stack/Stack'
import { Paragraph } from '../../Text/Paragraph'

import * as style from './RadioSelect/RadioSelect.css'

type Props<T extends FieldValues> = {
    value: string
    title: string | React.ReactNode
    description: string | React.ReactNode
    selected?: boolean
    children?: React.ReactNode
    name: string
    dataTestId?: string
    onClick?: () => void
} & Partial<UseFormReturn<T>>

export const RadioCard = <T extends FieldValues>(props: Props<T>) => {
    const { title, description, children, onClick, name, control } = props

    return (
        <Stack padding gap background="level2" cursor="pointer" borderRadius="sm" onClick={onClick}>
            <Stack horizontal gap justifyContent="spaceBetween" alignItems="center">
                <Stack gap="sm">
                    <Paragraph>{title}</Paragraph>
                    <Paragraph size="sm" color="gray2">
                        {description}
                    </Paragraph>
                </Stack>
                <Controller
                    name={name as Path<T>}
                    control={control}
                    render={({ field }) => {
                        return (
                            <Stack position="relative">
                                <input
                                    type="radio"
                                    color="negative"
                                    className={clsx([fieldStyles.field, style.radio])}
                                    name={field.name}
                                    checked={field.value === props.value}
                                    value={props.value}
                                    data-testid={props.dataTestId}
                                    onChange={() => field.onChange(props.value)}
                                />
                                <FieldOutline tone="neutral" disabled={false} rounded="full" />
                            </Stack>
                        )
                    }}
                />
            </Stack>
            {children}
        </Stack>
    )
}
